import axios from 'axios';

const BASE_URL = 'https://pixabay.com/api/';
const API_KEY = '53720827-61573bf1b5aa28f0604879aae';

export async function getImagesByQuery(query, page = 1) {
    const params = {
        key: API_KEY,
        q: query,
        image_type: 'photo',
        orientation: 'horizontal',
        safesearch: true,
        per_page: 15,
        page,
    };

    const { data } = await axios.get(BASE_URL, { params });
    return data;
}
